import magic from '../magic';
const specs={autofill:[0x2000,1,10],autoheat:[0x2001,1,1],target:[0x2002,1,100],floor:[0x2003,1,1],flush:[0x2004,1,1],
  immersion:[0x2006,4,0x7fffffff],soc:[0x2007,1,100],socTimer:[0x2008,4,0x7fffffff],wattSoc:[0x2009,1,100],wattTimer:[0x200a,4,0x7fffffff]};
const fields={autofill:['autofill_level',v=>v],autoheat:['autoheat',v=>v],target:['target_temp',v=>v],floor:['heatfloor',v=>v],flush:['flush_valve',v=>v],
  immersion:['immersion_timer_remaining',v=>Math.ceil(v/60)],soc:['soc_threshold',v=>v],socTimer:['soc_timer_remaining',v=>Math.ceil(v/3600)],wattSoc:['watt_soc_threshold',v=>v],wattTimer:['watt_timer_remaining',v=>Math.ceil(v/3600)]};
export async function writeWaterParameter(name,value){
  const spec=specs[name];
  if(!spec||!Number.isInteger(value)||value<0||value>spec[2])throw new Error(`Invalid hot-water ${name} value`);
  const [index,size]=spec;
  await magic.writeSDO(5,index,0,Uint8Array.from({length:size},(_,i)=>(value>>>(8*i))&255));
  const [field,convert]=fields[name];
  magic.hotWater[field]=convert(value);
  magic.bleEventDispatcher.emit('hotWater',magic.hotWater);
}
